import SuperAdminLayout from "SuperAdmin/SuperAdminLayout/SuperAdminLayout"
import SettingsNav from "SuperAdmin/SuperAdminNav/SettingsNav"



const OTPPageSettings = () =>{
    return<>
    <SuperAdminLayout>

        <SettingsNav />

        <h1> OTP Page Settings </h1>


    </SuperAdminLayout>
    
    </>
}
export default OTPPageSettings